import { MapPin, Clock, Phone, Navigation, MessageCircle, CalendarCheck } from 'lucide-react';
import { branch } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { BookNowButton } from './BookNowButton';
import { CALL_TEL, whatsappUrl, DIRECTIONS_URL, PHONE_DISPLAY } from './constants';

export const FindUs = () => {
  const { t } = useLang();
  return (
    <section id="find-us" className="py-14 lg:py-20 bg-surface border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading label={t.findUs.label} title={t.findUs.title} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
          <div className="bg-ink border border-white/10 p-7 flex flex-col gap-5">
            <h3 className="font-serif text-2xl text-gold">{t.findUs.shopName}</h3>
            <div className="flex items-start gap-3 text-sm text-white/75">
              <MapPin size={18} className="text-gold shrink-0 mt-0.5" />
              <span>{branch.address}</span>
            </div>
            <a href={CALL_TEL} className="flex items-center gap-3 text-sm text-white/75 hover:text-gold transition-colors" data-testid="findus-phone">
              <Phone size={18} className="text-gold shrink-0" />
              <span>{PHONE_DISPLAY}</span>
            </a>
            <div className="flex items-start gap-3 text-sm text-white/75">
              <Clock size={18} className="text-gold shrink-0 mt-0.5" />
              <div>
                <p className="text-xs uppercase tracking-widest text-gold mb-1">{t.findUs.hoursTitle}</p>
                <p>{t.findUs.weekday}</p>
                <p>{t.findUs.sunday}</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 mt-auto pt-2">
              <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border border-white/20 text-white hover:border-gold hover:text-gold font-bold uppercase tracking-widest px-4 py-3 text-xs transition-colors" data-testid="findus-directions-button">
                <Navigation size={15} /> {t.findUs.directions}
              </a>
              <a href={CALL_TEL} className="inline-flex items-center justify-center gap-2 border border-white/20 text-white hover:border-gold hover:text-gold font-bold uppercase tracking-widest px-4 py-3 text-xs transition-colors" data-testid="findus-call-button">
                <Phone size={15} /> {t.findUs.call}
              </a>
              <a href={whatsappUrl(t.whatsappMsg)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold uppercase tracking-widest px-4 py-3 text-xs hover:opacity-90 transition-opacity" data-testid="findus-whatsapp-button">
                <MessageCircle size={15} /> {t.findUs.whatsapp}
              </a>
              <BookNowButton
                testId="findus-book-now-button"
                className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-dark text-ink font-bold uppercase tracking-widest px-4 py-3 text-xs transition-colors"
              >
                <CalendarCheck size={15} /> {t.findUs.book}
              </BookNowButton>
            </div>
          </div>
          <div className="min-h-[340px] border border-white/10 overflow-hidden">
            <iframe
              src={branch.mapEmbed}
              title="The Real Turkish Barber Bray location map"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 340 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
